module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_mens_hair-23deea8dea9c7c3dda57c22493d937bd.jpg";